var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"saas-404"},[_c('img',{attrs:{"src":"/images/404.png","alt":""}}),_c('div',[_c('h1',[_vm._v("访问地址出错")]),_c('div',{staticClass:"text"},[_c('p',[_c('i'),_vm._v("请确认您访问的地址正确。")]),_c('p',[_c('i'),_vm._v("如果您觉得本提示信息有误，请及时联系您的管理员。")])])])])
}]

export { render, staticRenderFns }